import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import { WorkspaceProvider } from "@/contexts/WorkspaceContext";
import { Toaster } from "sonner";

export default function AppShell() {
  return (
    <WorkspaceProvider>
      <div className="min-h-screen bg-neutral-50">
        <Sidebar />
        <main className="ml-64 min-h-screen" data-testid="app-main">
          <Outlet />
        </main>
        <Toaster position="bottom-right" toastOptions={{ className: "font-medium rounded-sm" }} />
      </div>
    </WorkspaceProvider>
  );
}
